var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMiniStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00721 2.38586C5.89387 0.795288 6.3372 0 7 0C7.6628 0 8.10613 0.795287 8.99278 2.38586L9.22217 2.79736C9.47413 3.24935 9.60011 3.47535 9.79654 3.62446C9.99297 3.77358 10.2376 3.82893 10.7269 3.93963L11.1723 4.04042C12.8941 4.42999 13.755 4.62477 13.9598 5.28341C14.1646 5.94205 13.5777 6.62835 12.4039 8.00095L12.1003 8.35606C11.7667 8.74611 11.5999 8.94113 11.5249 9.1824C11.4499 9.42367 11.4751 9.68388 11.5255 10.2043L11.5714 10.6781C11.7489 12.5094 11.8376 13.4251 11.3014 13.8322C10.7652 14.2392 9.95913 13.8681 8.34703 13.1258L7.92996 12.9338C7.47185 12.7229 7.2428 12.6174 7 12.6174C6.7572 12.6174 6.52815 12.7229 6.07004 12.9338L5.65297 13.1258C4.04087 13.8681 3.23482 14.2392 2.6986 13.8322C2.16238 13.4251 2.25112 12.5094 2.42858 10.6781L2.47449 10.2043C2.52492 9.68388 2.55013 9.42367 2.4751 9.1824C2.40008 8.94113 2.2333 8.7461 1.89974 8.35606L1.59607 8.00095C0.422274 6.62835 -0.164623 5.94205 0.0401947 5.28341C0.245012 4.62477 1.1059 4.42999 2.82768 4.04042L3.27312 3.93963C3.7624 3.82893 4.00703 3.77358 4.20346 3.62446C4.39989 3.47535 4.52587 3.24935 4.77783 2.79736L5.00721 2.38586Z",
    fill: "#FFC149"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMiniStar);
export default __webpack_public_path__ + "static/media/ic_mini_star.79244be6cfc708cc249fdb82c460db13.svg";
export { ForwardRef as ReactComponent };